<template lang="html">
  <div class="container">
    <SoundslidesPlayer :path="path" :audio_source="audio_source" :use-show-dimensions="true" />
    <audio id="audioElement" controls controlsList="nodownload">
      <source :src="audioUrl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
import SoundslidesPlayer from "@/components/SoundslidesPlayer/SoundslidesPlayer"
export default {
  name: "ExternalAudio",
  components:{
    SoundslidesPlayer
  },
  data(){
    return {
      audio_source: null
    }
  },
  computed:{
    path(){
      var id = this.$route.params.id;
      if(id.length === 5){
        // Legacy hosting.
        return `https://s3.amazonaws.com/hosting.soundslides.com/${id}/`
      }else{
        return `https://s3.amazonaws.com/new.soundslides.hosting/${id}/`
      }
    },
    audioUrl(){
      return this.path + "audio_hi.mp3";
    }
  },
  mounted(){
    this.audio_source = this.$el.querySelector('#audioElement');
  }
}
</script>

<style lang="scss" scoped>
.container{
  position: relative;
}
#audioElement{
  position: relative;
  z-index: 100;
  top: 10px;
  left: 10px;
}
</style>
